import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '@services/config.service';
import { AuthService } from '@services/auth.service';

@Injectable()
export class ManualTokenInterceptor implements HttpInterceptor {
  private readonly config = inject(ConfigService);
  private readonly authService = inject(AuthService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.authService.getManualToken();
    if (!token || !req.url.startsWith(this.config.apiEndpoint)) {
      return next.handle(req);
    }
    return next.handle(req.clone({ setHeaders: { 'X-Manual-Token': token } }));
  }
}
